import { defineStore } from 'pinia'

export const useLoaderStore = defineStore('loader', {
  state: () => ({
    requestsPending: 0,
    signData: null,
    chunkIndex: 0,
    chunkAmount: 0,
  }),

  getters: {
    isLoading(state) {
      return state.requestsPending > 0
    },
    hasSignData(state) {
      return state.signData !== null
    }
  },

  actions: {
    showSignData(signData, chunkIndex = 0, chunkAmount = 0) {
      this.signData = signData
      this.chunkIndex = chunkIndex
      this.chunkAmount = chunkAmount
    },
    hideSignData() {
      this.signData = null
    },
    show() {
      this.requestsPending++
    },
    hide() {
      this.signData = null
      this.requestsPending = Math.max(this.requestsPending - 1, 0)
    },
  },
})
